import { Link } from '@tanstack/react-router';
import { Compass, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState, Spinner } from '@/components/ui/misc';
import { BrandMark } from './brand';

export function SplashScreen() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <BrandMark className="size-10" />
      <Spinner />
    </div>
  );
}

export function NotFound() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <EmptyState
        icon={<Compass />}
        title="Page not found"
        description="The page you are looking for does not exist or has moved."
        action={
          <Link to="/">
            <Button variant="secondary">Back to modules</Button>
          </Link>
        }
      />
    </div>
  );
}

export function Forbidden({ what = 'this page' }: { what?: string }) {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <EmptyState
        icon={<Lock />}
        title="Access denied"
        description={`You do not have permission to open ${what}. Contact your administrator if you need access.`}
      />
    </div>
  );
}
